import { toast } from "react-toastify";
import { getTokenFromLocal, handleResponse } from "../../_helpers/handleResponseMiddleware";

let centralBaseUrl = process.env.REACT_APP_CENTRAL_BASE_URL;
let centralCommonUrl = process.env.REACT_APP_BASE_URL_COMMON;
const centralNodeBaseUrl = process.env.REACT_APP_CENTRAL_UPLOAD_URL;
export const aws_bucket_url = process.env.REACT_APP_AWS_BUCKET_URL;

export function getCentralReportingDataService(params) {
  
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;

        let currentDate = new Date();
        // Get date upcoming 11 days
        currentDate.setDate(currentDate.getDate() + 11);
        let currentISODate = currentDate.toISOString();

        // Get date 11 days before
        let fifteenDaysAgo = new Date(Date.now() - (11 * 24 * 60 * 60 * 1000));
        let fifteenDaysAgoISO = fifteenDaysAgo.toISOString();
    const paramsData =  {
      ...params,
      appDate :{"startDate":fifteenDaysAgoISO,"endDate":currentISODate}
    }

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // mobileplatform: "web",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...paramsData }),
    };
    return fetch(
      `${centralBaseUrl}/getReportingData`,
      requestOptions
    )
      .then(handleResponse)
      .then(res => res)
      .catch(function (error) {
        console.error(error);
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }

export function updateCentralReportingData(params) {
  
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // mobileplatform: "web",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...params }),
    };
    return fetch(
      `${centralBaseUrl}/updateCentralDashRepoting`,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        if(res.status===200){
          // toast.success(res.message)
        }
        return res;
      })
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        console.log("response",JSON.stringify(response))
        return response ;
      });
  }

export function updateCentralPreAuthStatus(params) {
  
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
    let formData = new FormData();
    for (const key in params) {
      formData.append(key, params[key]);
    }

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };
    return fetch(
      `${centralCommonUrl}/api/v2/updateStatusForCashless`,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        if(res.status===200){
          // toast.success(res.message)
        }
        if(res.status==='Failed'){
          toast.error(res.description)
        }
      })
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }

export function getCentralFinalBillStatus(appId) {
  
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return fetch(
      `${centralBaseUrl}/fetchFinalBillByAppointmentId?appointmentId=${appId}`,
      requestOptions
    )
      .then(handleResponse)
      .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }

export function getDaDocuments(leadId) {
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return fetch(
      `${centralNodeBaseUrl}/central-dashboard/get-da-documents?leadId=${leadId}`,
      requestOptions
    )
      .then(handleResponse)
      .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
}
